// extracted by mini-css-extract-plugin
export default {"container":"admin_container__d7WTx","title":"admin_title__JJGV4","grid":"admin_grid__DFHt3","card":"admin_card__+aVxj"};